import * as React from "react";

import { styled } from "@mui/material/styles";
import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Collapse,
  Icon,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect } from "react";
import AnalyticsService from "data/firestore/analytics";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <Icon {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function ExpandableCard({
  title,
  subtitle,
  icon,
  children,
  openedByDefault = true,
  style,
  onExpand,
}) {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    const newExpandedState = !expanded;
    if (newExpandedState) {
      onExpand?.();
      AnalyticsService.event("expand_card", { card: subtitle || title });
    }
    setExpanded(newExpandedState);
  };

  useEffect(() => {
    setExpanded(openedByDefault);
  }, [openedByDefault]);

  return (
    <Card
      style={{
        border: "0.5px solid",
        borderColor: "lightgrey",
        margin: "10px 0px",
        fontFamily: "Inter",
        fontWeight: 300,
        ...style,
      }}
    >
      <CardActionArea onClick={handleExpandClick}>
        <CardHeader
          avatar={icon}
          action={
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
              style={{ margin: 8 }}
            >
              <ExpandMoreIcon />
            </ExpandMore>
          }
          title={title}
          subheader={subtitle}
          style={{ padding: 16 }}
        />
      </CardActionArea>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent
          style={{ display: "flex", flexFlow: "column", padding: 8 }}
        >
          {children}
        </CardContent>
      </Collapse>
    </Card>
  );
}
